// for explicit conversion of date string to date instance that is supported by validatorjs,
// kindly add those fields into the dateFields array
export const dateFields = ['valid_to', 'valid_from']
